<template>
   <PageFull header="Адм. получатели" type="white" :fullwidth="true" :nopadding="true">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <RecipientsList />
            </div>  
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import RecipientsList from '@/components/admin/RecipientsList.vue' 
import PageFull from '@/components/sides/PageFull.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        RecipientsList,
        PageFull
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>